// file path: src\stores\auth.store.ts

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth.slice';
import projectKanbanReducer from '../Pages/Project/Kanban/store/ProjectKanban.slice';
import billingReducer from './billing.slice';
import workbotReducer from '../Pages/WorkBot/stores/workbot.slice';
import messagesReducer from '../Pages/WorkBot/stores/messages.slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    projectKanban: projectKanbanReducer,
    billing: billingReducer,
    workbot: workbotReducer,
    messages: messagesReducer,
  },
});

// Define the RootState and AppDispatch types based on the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
